document.addEventListener('turbolinks:load', () => {
  const headers = document.querySelectorAll(".c-fieldsetDivide__grpHeader");

  headers.forEach(header => {
    const section = header.parentElement;
    const content = section.querySelector(".c-fieldsetDivide__grpContent");
    const caret = header.querySelector(".accCaret");
    const path = window.location.pathname;

    if (path.includes('/sites') && path.includes('/site_users')) {
      content.classList.add("accExpand");
    }

    if (content.classList.contains("accExpand")) {
      caret.style.transform = "rotate(180deg)";
    }

    header.addEventListener("click", () => {
      const isExpanded = content.classList.contains("accExpand");
      content.classList.toggle("accExpand");
      caret.style.transform = isExpanded ? "" : "rotate(180deg)";
    });
  });
});